import React from 'react'

function LogoutPage() {
  return (
    <div>LogoutPage</div>
  )
}

export default LogoutPage